<template>
  <Layout>
    <PageHeader :title=title :items="itemHeader"></PageHeader>
    <div class="mb-3 d-flex justify-content-between align-center">
      <label class="flex flex-row gap-4 align-center m-0 fs-14">
      {{ $t('t-facility_type') }}
        
      <div class="flex flex-row gap-4">
        <div class="form-check form-radio-check">
          <input
            class="form-check-input"
            type="radio"
            name="type"
            id="facility_sauna"
            value="SAUNA"
            v-model="tempType"
          />
          <label class="form-check-label fs-14" for="facility_sauna">
            {{ $t('t-sauna')}}
          </label>
        </div>

        <div class="form-check form-radio-check">
          <input
            class="form-check-input"
            type="radio"
            name="type"
            id="facility_lounge"
            value="ROOM"
            v-model="tempType"
          />
          <label class="form-check-label fs-14" for="facility_lounge">
            {{ $t('t-room_lounge')}}
          </label>
        </div>
      </div>
    </label>
      
      <b-button variant="primary" @click="addFacility" :disabled="state.loadingAction" class="waves-effect waves-light">
        <div class="flex">
                <span v-if="state.loadingAction" class="d-flex align-items-center mr-2">
                  <Loading/>
                </span>
          {{ $t("t-register-btn") }}
        </div>
      </b-button>
    </div>
    <div class="row">
      <div class="col-xxl-9 col-md-9">
        <div class="row">
          <div class="col-xxl-12 col-md-12">
            <facility-information
                @reload="loadFacility"
                @createFacility="setParamFacility"
                  @onChangeType="onChangeType"
                :facility="state.facility"
                :is-create="true"
                :facility-id-str="state.facilityIdStr"
                :is-sauna="state.formPayloadCreateFacility.type === 'SAUNA'"
                :initial-type="state.formPayloadCreateFacility.type"
                ref="facility-information"
            />
          </div>

          <div class="col-xxl-12 col-md-12">
            <Room
                room-sub-type="SAUNA_DRIED"
                :facility="state.facility"
                :is-create="true"
                :facility-type="state.formPayloadCreateFacility.type"
                :title="state.formPayloadCreateFacility.type === 'SAUNA' ? 't-sauna-room-information' : 't-room-information'"
                @createRoom="setParamRoom"
                ref="room_SAUNA_DRIED"
            />
          </div>
          
          <div
            v-if="state.formPayloadCreateFacility.type === 'SAUNA'"
            class="col-xxl-12 col-md-12"
          >
            <Room
              room-sub-type="SAUNA_WET"
              :facility="state.facility"
              :is-create="true"
              @createRoom="setParamRoom"
              ref="room_SAUNA_WET"
              :title="'t-water-bath-information'"
            />
          </div>

          <div 
            v-if="state.formPayloadCreateFacility.type === 'SAUNA'"
            class="col-xxl-12 col-md-12"
          >
            <Room
              room-sub-type="SAUNA_RESTED"
              :facility="state.facility"
              :is-create="true"
              @createRoom="setParamRoom"
              ref="room_SAUNA_RESTED"
              :title="'t-break-information'"
            />
          </div>
        </div>
      </div>
      <div class="col-xxl-3 col-md-3">
        <div class="row">
          <div v-if="state.formPayloadCreateFacility.type === 'SAUNA'" class="col-xxl-12 col-md-12">
            <FacilityFilterInformation
                :facility="state.facility"
                :is-create="true"
                @createService="setParamService"
                ref="facility_filter_information"
            />
          </div>
          <div class="col-xxl-12 col-md-12">
            <Settings
              :is-create="true"
              ref="facility_settings"
            />
          </div>
          <div class="col-xxl-12 col-md-12">
            <SettingAds
                @createSettingAds="setParamSettingAds"
                :is-create="true"
                ref="facility_setting_ads"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/main.vue'
import PageHeader from "@/components/page-header.vue";
import { onMounted, reactive, ref, watch } from "vue";
import i18n from "@/i18n";
import FacilityInformation from "@/views/setting/facility-management/components/FacilityInformation.vue";
import Room from "@/views/setting/facility-management/components/Room.vue"
import Settings from "@/views/setting/facility-management/components/Settings.vue";
import SettingAds from "@/views/setting/facility-management/components/SettingAds.vue";
import FacilityFilterInformation from "@/views/setting/facility-management/components/FacilityFilterInformation.vue";
import Loading from "@/components/Loading";
import {concat, get} from "lodash";
import {facilityService} from "@/services";
import Swal from "sweetalert2";
import { getCurrentInstance } from 'vue';

const initData = {
  facility: {},
  formPayloadCreateFacility: {
    rooms: [],
    facilityServices: [],
    playlistId: '',
    type: 'SAUNA',
  },
  loadingAction: false,
  validate: {
    formFacility: false,
    SAUNA_DRIED: true,
    SAUNA_WET: true,
    SAUNA_RESTED: true
  },
  facilityIdStr: ''
}
export default {
  components: {
    Layout,
    PageHeader,
    FacilityInformation,
    Room,
    Settings,
    SettingAds,
    FacilityFilterInformation,
    Loading
  },
  setup() {
    const instance = getCurrentInstance();
    const pendingType = ref(null);
    const loadingAction = ref(false);
    const facility_settings = ref(null);
    const room_SAUNA_DRIED = ref(null);
    const facility_setting_ads = ref(null);
    const title = ref(i18n.global.t('facility.facility-details'));
    const itemHeader = reactive([
      {
        text: i18n.global.t('facility.facility-information'),
        href: "/admin/facility/list",
      },
      {
        text: i18n.global.t('facility.facility-details'),
        active: true,
      },
    ]);

    const state = reactive({...initData})
    const tempType = ref(state.formPayloadCreateFacility.type);
    
    const loadFacility = () => {
      console.log('loadFacility')
    }

    const setParamFacility = async (formFacility) => {
      state.validate.formFacility = formFacility.validate;

      if (formFacility.validate) {
        state.formPayloadCreateFacility = {
          ...state.formPayloadCreateFacility,
          ...formFacility.payload,
          type: state.formPayloadCreateFacility.type
        };
      }
    }
    const setParamRoom = (formRoom) => {
      if (formRoom.validate) {
        state.formPayloadCreateFacility.rooms = concat(...state.formPayloadCreateFacility.rooms, ...formRoom.payload);
      }

      state.validate[formRoom.type] = formRoom.validate;
    }
    const setParamService = (formService) => {
      state.formPayloadCreateFacility.facilityServices = formService;
    }

    const setParamSettingAds = (value) => {
      state.formPayloadCreateFacility.playlistId = value
    }

    const refreshPayload = () => {
      const { type } = state.formPayloadCreateFacility;
      state.formPayloadCreateFacility = {
        rooms: [],
        facilityServices: [],
        type,
      }
    }

    const updateStateFacility = (facilityIdStr) => {
      state.facilityIdStr = facilityIdStr
    }

    const handleChangeLoading = (value) => {
      state.loadingAction = value
    }

    const onChangeType = async (newValue) => {
      if (newValue === state.formPayloadCreateFacility.type) return;
      
      const accept = await Swal.fire({
        title: `<h2 class='swal2-title' id='swal2-title' style='display: block; font-size: 20px !important;padding-top: 0 !important; font-weight: bold'>変更確認</h2>`,
        html:  `<h2 class='swal2-title' id='swal2-title' style='display: block; font-size: 20px !important; padding-top: 0 !important;'>施設種別を変更すると、既存のデータは全部リセットされます。よろしいですか？</h2>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "変更",
        cancelButtonText: "キャンセル",
      });

      if (accept.value) {
        tempType.value = newValue;
        pendingType.value = newValue;

        confirmChangeType();
      } else {
        onModalClosed();
      }
    };
    
    const confirmChangeType = () => {
      if (pendingType.value) {
        state.formPayloadCreateFacility.type = pendingType.value;
        tempType.value = pendingType.value;

        Object.assign(state, { ...initData, formPayloadCreateFacility: { ...initData.formPayloadCreateFacility, type: pendingType.value } });
        const comp = instance?.proxy?.$refs['facility-information'];
        room_SAUNA_DRIED.value?.resetValue();
        facility_settings.value?.resetValue();
        facility_setting_ads.value?.resetValue();
        comp?.resetForm();
      }
    }
    
    const onModalClosed = () => {
      pendingType.value = null;
      tempType.value = state.formPayloadCreateFacility.type;
    }
    
    watch(() => tempType.value, (newValue) => {
      onChangeType(newValue);
    })

    onMounted(() => {
      Object.assign(state, JSON.parse(JSON.stringify(initData)));
      tempType.value = state.formPayloadCreateFacility.type;
    });

    return {
      title,
      itemHeader,
      state,
      loadingAction,
      tempType,
      room_SAUNA_DRIED,
      facility_settings,
      facility_setting_ads,
      onModalClosed,
      confirmChangeType,
      onChangeType,
      loadFacility,
      setParamFacility,
      setParamRoom,
      setParamService,
      refreshPayload,
      updateStateFacility,
      handleChangeLoading,
      setParamSettingAds
    }
  },

  methods: {
    async addFacility() {
      this.handleChangeLoading(true);
      this.refreshPayload()
      this.$refs['facility-information'].onSubmit();
      this.$refs['room_SAUNA_DRIED'].onSubmit();
      if (this.state.formPayloadCreateFacility.type === 'SAUNA') {
        this.$refs['room_SAUNA_WET'].onSubmit();
        this.$refs['room_SAUNA_RESTED'].onSubmit();
        this.$refs['facility_filter_information'].onSubmit();
      }
      
      this.$refs['facility_settings'].onSubmit();
      this.$refs['facility_setting_ads'].onSubmit();

      setTimeout( async () => {
        try {
          if (Object.values(this.state.validate).some(item => !item)) {
            return;
          }
          const res = await facilityService.createFacility(this.state.formPayloadCreateFacility);
          this.updateStateFacility(res.facilityIdStr);
          await this.$router.push({name: 'admin-facility-list'});

          this.$store.commit('settings/SET_POPUP', {
            show: true,
            type: 'success',
            message: i18n.global.t('msg.saved')
          });
        } catch (e) {
          const message = get(e, 'response.data.message', '');
          await Swal.fire({
            title: "Create failed",
            text: message,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
        } finally {
          this.handleChangeLoading(false)
        }
      }, 1000)

    }
  }
}
</script>
